import LandscapePopup from "components/landscape-popup/landscape-popup";
export default LandscapePopup;
